import { isProduction } from "@config/site/helpers";
import { activeSiteConfig, getLanguageFromLocale } from "@config/site/site-config";
import Script from "next/script";

const QUEBEC_COOKIE_CONSENT_DOMAIN = "fake.qc.ecco.com";

interface CookieConsentScriptProps {
    locale: string;
}

export const CookieConsentScript = ({ locale }: CookieConsentScriptProps) => {
    const marketLanguage = getLanguageFromLocale(locale).toUpperCase();
    const supportGPC = activeSiteConfig.supportsGlobalPrivacyControl;
    const hostname = process.env.NEXT_PUBLIC_HOSTNAME;

    return (
        <Script id="CookieConsentLoader" strategy="afterInteractive">{`
(function() {
    var isQuebec = document.cookie.indexOf("x-geo-region=QC") !== -1;
    var supportGPC = ${supportGPC ? "true" : "false"};
    var isProductionEnv = ${isProduction ? "true" : "false"};

    // Set up GPP config for non-Quebec visitors with GPC support.
    // Quebec (Law 25) does not use GPP, so we skip it for that region.
    if (supportGPC && !isQuebec) {
        window.cookieInformationCustomConfig = {
            GPP: {
                applicableSections: [
                    { id: 7, name: "usnatv1" },
                    { id: 8, name: "uscav1" },
                    { id: 10, name: "uscov1" },
                    { id: 12, name: "usctv1" }
                ]
            }
        };
    }

    // Inject the Cookie Information script with the correct attributes.
    // We do this inline (instead of using next/script for uc.js directly) because
    // the cs-id attribute must be set before uc.js executes, and the geo region
    // is only available client-side via the x-geo-region cookie set by middleware.
    var script = document.createElement("script");
    script.id = "CookieConsent";
    script.src = "https://policy.app.cookieinformation.com/uc.js";
    script.type = "text/javascript";
    script.setAttribute("data-culture", "${marketLanguage}");
    script.setAttribute("data-gcm-version", "2.0");

    // Quebec: load the Quebec-specific consent solution (Law 25)
    // Non-production + non-Quebec: use hostname so preview deploys load the correct config
    if (isQuebec) {
        script.setAttribute("cs-id", "${QUEBEC_COOKIE_CONSENT_DOMAIN}");
    } else if (!isProductionEnv) {
        script.setAttribute("cs-id", "${hostname}");
    }

    if (supportGPC && !isQuebec) {
        script.setAttribute("data-gpp-enabled", "true");
    }

    document.head.appendChild(script);
})();
`}</Script>
    );
};
